import React from "react";
import "./SecondSlideOrbiterYoghurt.scss";
import { translate } from "../../localization/TranslationUtil";
import TextCaption from "../../components/TextCaption/TextCaption";

const SecondSlideOrbiterYoghurt = ({}) => {
  return (
    <div className="orbiterStorySecondSlide">
      <div className="orbiterStorySecondSlide--background">
        <TextCaption additionalCssClassname="orbiterStorySecondSlide--textCaption">
          <div className="orbiterStorySecondSlide--text">
            {translate("ORBITER_SECOND_SLIDE_YOGHURT")}
          </div>
        </TextCaption>
        <div className="orbiterStorySecondSlide--robot"></div>
        <div className="orbiterStorySecondSlide--pipe"></div>
        <div className="orbiterStorySecondSlide--tree"></div>
      </div>
    </div>
  );
};

export default SecondSlideOrbiterYoghurt;
